import { FloatingArrow, FloatingNode, FloatingPortal, arrow, autoUpdate, offset, shift, useDismiss, useFloating, useFloatingNodeId, useFocus, useHover, useInteractions, useRole, } from '@floating-ui/react';
import React, { useRef, useState } from 'react';
import style from './Tooltip.module.scss';
export function Tooltip({ tooltip, children }) {
    const arrowRef = useRef(null);
    const nodeId = useFloatingNodeId();
    const [isOpen, setIsOpen] = useState(false);
    const { x, y, strategy, refs, context } = useFloating({
        open: isOpen,
        onOpenChange: setIsOpen,
        middleware: [
            offset(10),
            shift(),
            arrow({
                element: arrowRef,
            }),
        ],
        whileElementsMounted: autoUpdate,
    });
    const hover = useHover(context, { move: false });
    const focus = useFocus(context);
    const dismiss = useDismiss(context);
    const role = useRole(context, { role: 'tooltip' });
    // Merge all the interactions into prop getters
    const { getReferenceProps, getFloatingProps } = useInteractions([hover, focus, dismiss, role]);
    return (React.createElement(React.Fragment, null,
        React.createElement("button", { type: "button", className: style.button, ref: refs.setReference, ...getReferenceProps() }, children),
        isOpen && (React.createElement(FloatingNode, { id: nodeId },
            React.createElement(FloatingPortal, null,
                React.createElement("div", { className: style.tooltip, ref: refs.setFloating, style: {
                        position: strategy,
                        top: y ?? 0,
                        left: x ?? 0,
                        width: 'max-content',
                        zIndex: 1021, // 1020 = header
                    }, ...getFloatingProps() },
                    tooltip,
                    React.createElement(FloatingArrow, { ref: arrowRef, context: context, height: 6, width: 12, fill: "#E60032" })))))));
}
